import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";

import { InboundReportPage } from "@/features/reports";

type InboundSearchParams = { highlight?: string };

function parseInboundSearch(raw: Record<string, unknown>): InboundSearchParams {
  if (typeof raw.highlight === "string" && raw.highlight) return { highlight: raw.highlight };
  return {};
}

function InboundRoute(): JSX.Element {
  const { highlight } = Route.useSearch();
  return highlight ? <InboundReportPage highlight={highlight} /> : <InboundReportPage />;
}

export const Route = createFileRoute("/_authenticated/inbound-report")({
  validateSearch: (search): InboundSearchParams =>
    parseInboundSearch(search as Record<string, unknown>),
  component: InboundRoute,
});
